import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { AnimatePresence, motion } from 'motion/react';
import { classNames } from '@frontend/string';

export const AnimatedExpandedRow = ({ children, isExpanded }: { children: ReactNode; isExpanded: boolean }) => {
  return (
    <AnimatePresence initial={false}>
      {isExpanded && (
        <motion.section
          key='content'
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
          role='region'
          className={classNames('compact-table-row')}
          css={[
            css`
              overflow: hidden;
              width: 100%;
            `,
          ]}
        >
          {children}
        </motion.section>
      )}
    </AnimatePresence>
  );
};
